module.exports = __webpack_public_path__ + "static/media/mail.f13f872f.svg";